export { BannerNew } from "./bannerNew";
